import React from 'react';
import UserGroupRow from './UserGroupRow';

const UserGroupsTableRows = ({ columns, items, onCheckBoxClick }) => (
  items.map((item, index) => (
    <UserGroupRow
      columns={columns}
      key={`user_groups_table_row_${item.code}`}
      onCheckBoxClick={onCheckBoxClick}
      upward={index > 4}
      userGroup={item}
    />
  ))
);

export default UserGroupsTableRows;
